export const GET_LANGUAGES_LOADING = 'GET_LANGUAGES_LOADING';
export const GET_LANGUAGES_SUCCESS = 'GET_LANGUAGES_SUCCESS';
export const GET_LANGUAGES_FAILURE = 'GET_LANGUAGES_FAILURE';
export const EDIT_LANGUAGE_LOADING = 'EDIT_LANGUAGE_LOADING';
export const EDIT_LANGUAGE_SUCCESS = 'EDIT_LANGUAGE_SUCCESS';
export const EDIT_LANGUAGE_FAILURE = 'EDIT_LANGUAGE_FAILURE';
export const ADD_LANGUAGE_LOADING = 'ADD_LANGUAGE_LOADING';
export const ADD_LANGUAGE_SUCCESS = 'ADD_LANGUAGE_SUCCESS';
export const ADD_LANGUAGE_FAILURE = 'ADD_LANGUAGE_FAILURE';
